var map = {
	"./Datawranglingio.png": "80c1",
	"./Rebasive.png": "4cd0",
	"./Reliance.png": "a970",
	"./ahk-nigeria-logo.png": "65c0",
	"./ahk-nigeria-logo@2x.png": "309b",
	"./ahk-nigeria-logo@3x.png": "d609",
	"./bongohive.png": "0f83",
	"./catalystFund.png": "1918",
	"./dg.svg": "50e9",
	"./dufuna-logo.svg": "1fe7",
	"./dufuna-new-logo.svg": "1961",
	"./dufuna-white-logo.svg": "730d",
	"./dufunaNew.png": "4a99",
	"./enterfive.png": "cb8a",
	"./exins.svg": "3f0c",
	"./group.svg": "5bc9",
	"./hero-img.png": "781e",
	"./hero-img@2x.png": "0f15",
	"./hero-img@3x.png": "0038",
	"./infinion-logo.png": "590c",
	"./innovective.png": "ef6e",
	"./integrated-software-services-new.png": "9ade",
	"./konganew.png": "f78b",
	"./law-pavillion.png": "0fcc",
	"./logo-copy@2x.png": "cedf",
	"./logo-copy@3x.png": "6b47",
	"./logo.svg": "a7cb",
	"./miadria.svg": "d318",
	"./nationalFinancial.png": "3c03",
	"./paradigm.svg": "8c32",
	"./paradigmIni.png": "74f9",
	"./request.png": "01a0",
	"./request@2x.png": "3dee",
	"./request@3x.png": "b9b7",
	"./sheworks.svg": "6b7b",
	"./sheworksnew.png": "e77e",
	"./sheworkswhite.png": "5940",
	"./talent-blue-logo.png": "4d14",
	"./talent-logo-white.svg": "e66d",
	"./tek-experts.png": "5e1d",
	"./ukNigeriaTechHub.png": "3126",
	"./zazu.svg": "7762"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ac0";